var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 8,
    fill: "#E8EEF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_875_2694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0835 6.66675H7.66683C7.1806 6.66675 6.71428 6.8599 6.37047 7.20372C6.02665 7.54754 5.8335 8.01385 5.8335 8.50008V21.3334C5.8335 21.8196 6.02665 22.286 6.37047 22.6298C6.71428 22.9736 7.1806 23.1667 7.66683 23.1667H20.5002C20.9864 23.1667 21.4527 22.9736 21.7965 22.6298C22.1403 22.286 22.3335 21.8196 22.3335 21.3334V14.9167",
    stroke: "#003DA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9585 5.29171C21.3232 4.92704 21.8178 4.72217 22.3335 4.72217C22.8492 4.72217 23.3438 4.92704 23.7085 5.29171C24.0732 5.65638 24.278 6.15099 24.278 6.66671C24.278 7.18244 24.0732 7.67704 23.7085 8.04171L15.0002 16.75L11.3335 17.6667L12.2502 14L20.9585 5.29171Z",
    stroke: "#003DA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_875_2694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/editar.f1e238658363784628f7d6e5c4f85651.svg";
export { ForwardRef as ReactComponent };